import { useDispatch, useSelector } from 'react-redux'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'
import Input from '../../../../../UI/Input/Input'

const OperatingCost = ({ payload, widthInPercent }) => {
  const translations = useSelector((state) => state.translations)
  const newObject = useSelector((state) => state.OBJECT)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    // dispatch(setNewObject({ ...newObject, operatingCost: { ...newObject.operatingConst, [key]: value } }))
    dispatch(setLocal(props.OBJECT, { ...newObject, operatingCost: { ...newObject.operatingConst, [key]: value } }))
  }

  return (
    <div className="wrapper" style={{ width: `${widthInPercent}%` }}>
      <div className="group">
        <div className="label">{translations['object.operatingcost']}</div>
        <div className="values">
          <Input type="number" value={newObject.operatingCost.recoverable} onChange={update('recoverable')} placeholder={translations['object.operatingcost.recoverable']} />
          <Input type="number" value={newObject.operatingCost.notRecoverable} onChange={update('notRecoverable')} placeholder={translations['object.operatingcost.notrecoverable']} />
        </div>
      </div>
    </div>
  )
}

export default OperatingCost
